module.exports = __webpack_public_path__ + "static/media/giphy-6.2e0bc187.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-6.gif
// module id = 177
// module chunks = 0